<template>
  <div>
    <div
      v-for="id in ids"
      :key="id"
      class="mb-3"
      style="page-break-after: always;"
    >
      <RecipeViewer :id="id" hide-options mounted-mode></RecipeViewer>
    </div>
  </div>
</template>

<script>
import RecipeViewer from "./RecipeViewer";
export default {
  name: "RecipeListViewer",
  components: {
    RecipeViewer
  },
  props: {
    ids: {
      type: Array,
      required: true
    }
  },
  async created() {
    await Promise.all([
      this.$store.dispatch("loadProducts"),
      this.$store.dispatch("loadIngredients")
    ]);
  }
};
</script>

<style></style>
